// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"SuggestionDropdown_dropdown__1dKWz"};